import React from "react";

const WorkProcess = () => {
  return (
    <section
      className="space process-sec"
      data-overlay="title"
      data-opacity="9"
      data-bg-src="/assets/img/update1/bg/process_bg_1.jpg"
    >
      <div className="container mb-n2">
        <div className="title-area text-center">
          <span className="sub-title6 text-white justify-content-center">
            <span className="shape left">
              <span className="dots"></span>
            </span>
            HOW WE WORK
            <span className="shape right">
              <span className="dots"></span>
            </span>
          </span>
          <h2 className="sec-title text-white">Our Work Process</h2>
        </div>

        <div className="row gy-40 justify-content-between">
          {/* Step 1: Inspection */}
          <div className="col-sm-6 col-lg-auto process-card2-wrap">
            <div className="process-card2">
              <div className="process-card2_icon">
                <i className="fal fa-search-location"></i>
              </div>
              <h2 className="process-card2_title">Inspection</h2>
              <p className="process-card2_text">
                We inspect the space to identify pest or cleaning issues.
              </p>
            </div>
          </div>

          {/* Step 2: Planning */}
          <div className="col-sm-6 col-lg-auto process-card2-wrap">
            <div className="process-card2">
              <div className="process-card2_icon">
                <i className="fal fa-clipboard-list"></i>
              </div>
              <h2 className="process-card2_title">Planning</h2>
              <p className="process-card2_text">
                A customized plan is created for effective service.
              </p>
            </div>
          </div>

          {/* Step 3: Execution */}
          <div className="col-sm-6 col-lg-auto process-card2-wrap">
            <div className="process-card2">
              <div className="process-card2_icon">
                <i className="fal fa-broom"></i>
              </div>
              <h2 className="process-card2_title">Execution</h2>
              <p className="process-card2_text">
                Our team carries out the service with care and precision.
              </p>
            </div>
          </div>

          {/* Step 4: Follow-up */}
          <div className="col-sm-6 col-lg-auto process-card2-wrap">
            <div className="process-card2">
              <div className="process-card2_icon">
                <i className="fal fa-check-circle"></i>
              </div>
              <h2 className="process-card2_title">Follow-up</h2>
              <p className="process-card2_text">
                We follow up to ensure complete satisfaction and results.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkProcess;
